import type { EventId, PlanEvent, Task } from "../../../../shared/types";
import type { UpdateEventData } from "../../types/event-form-types";
import { DailyChecklist } from "../DailyChecklist";
import { ImageGallery } from "../../../images/components/ImageGallery";
import { EventItemFields } from "./EventItemFields";
import { EventItemMeta } from "./EventItemMeta";
import { EventLinkedTasks } from "./EventLinkedTasks";
import * as taskStore from "../../../tasks/store/task-store";
import { toggleTaskDone } from "../../../tasks/store/task-store";

interface EventItemExpandedProps {
  readonly event: PlanEvent;
  readonly linkedTasks: readonly Task[];
  readonly editingField: string | null;
  readonly editValue: string;
  readonly onStartEdit?: (field: string, value: string) => void;
  readonly onSaveEdit?: () => void;
  readonly onEditValueChange?: (value: string) => void;
  readonly onUpdate?: (id: EventId, updates: UpdateEventData) => void;
  readonly readOnly?: boolean;
}

export function EventItemExpanded({
  event,
  linkedTasks,
  editingField,
  editValue,
  onStartEdit,
  onSaveEdit,
  onEditValueChange,
  onUpdate,
  readOnly,
}: EventItemExpandedProps) {

  return (
    <div className="px-4 py-3 bg-surface-alt border-t border-border space-y-3">
      {(event.eventSubtasks?.length ?? 0) > 0 && (
        <DailyChecklist
          eventTitle={event.title}
          subtasks={event.eventSubtasks ?? []}
          readOnly={readOnly}
        />
      )}

      <EventLinkedTasks
        eventId={event.id}
        eventCategory={event.category}
        eventDate={event.date}
        tasks={linkedTasks}
        readOnly={readOnly}
        onToggleTask={readOnly ? (() => {}) : toggleTaskDone}
        onAddTask={readOnly ? (() => {}) : taskStore.addTaskForEvent}
        onUnlinkTask={readOnly ? (() => {}) : (id) => taskStore.updateTask(id, { eventId: null })}
        onDeleteTask={readOnly ? (() => {}) : taskStore.deleteTask}
      />

      {!readOnly && <ImageGallery entityType="event" entityId={event.id} />}

      <EventItemFields
        event={event}
        editingField={readOnly ? null : editingField}
        editValue={editValue}
        onStartEdit={readOnly ? undefined : onStartEdit}
        onSaveEdit={readOnly ? undefined : onSaveEdit}
        onEditValueChange={readOnly ? undefined : onEditValueChange}
        onUpdate={readOnly ? undefined : onUpdate}
      />
      <EventItemMeta
        recurrence={event.recurrence ?? undefined}
        reminderMinutes={event.reminderMinutes}
        eventDate={event.date}
      />
    </div>
  );
}
